import { render, staticRenderFns } from "./ResourcesComponent.vue?vue&type=template&id=5ff713ec&scoped=true&"
import script from "./ResourcesComponent.vue?vue&type=script&lang=js&"
export * from "./ResourcesComponent.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesComponent.vue?vue&type=style&index=0&id=5ff713ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff713ec",
  null
  
)

export default component.exports